class LocalStorageProxy {
  constructor() {
    this.storage = window.localStorage;
    if (checkLocalStorageSize()) {
      this.clear(); //清空localStorage
      location.reload(); //刷新页面
    }
  }
  /**
   * @param {String} k
   */
  remove(k) {
    localStorage.removeItem(k);
  }
  /**
   * @returns {void}
   */
  clear() {
    localStorage.clear();
  }
  /**
   * 设置缓存
   * @param {String} k
   * @param {Any} v
   * @param {timeStamp} t
   */
  set(k, v, t) {
    //缓存时间默认7天
    let now = Date.now();
    t = t ? t + now : now + 7 * 86400000;
    localStorage.setItem(
      k,
      JSON.stringify({
        value: v,
        exist_time: t
      })
    );
  }
  /**
   * 获取缓存
   * 改写了方法,不再与其他形式localStorage存储兼容,
   * 若不符合该Class的存储规则,调用get则直接返回null
   * @param {String} k
   */
  get(k) {
    let v = localStorage.getItem(k);
    if (v) {
      try {
        v = JSON.parse(v);
      } catch {
        return null;
      }
      if (!v.exist_time) {
        //若不存在existTime(直接使用原生缓存),则直接返回结果
        return null;
      }
      if (Date.now() > v.exist_time) {
        //缓存超时
        this.remove(k); //删除该项
        return null; //返回空值
      } else {
        return v.value;
      }
    } else {
      return null;
    }
  }
}

//保险起见,把key也算进存储空间,大于3M就预警,页面并不需要localStorage作为依赖
function checkLocalStorageSize() {
  let size = Object.keys(window.localStorage).reduce((size, key) => {
    return size + key.length + window.localStorage[key].length;
  }, 0);
  return size / 1024 / 1024 > 3;
}

export default new LocalStorageProxy();
